/* SS 30.09.2026 (Kristoffer, sketch B) - family products with several kids types («Barn Overall», «Barn Vanlig», «Barn Løs»).

   The Type row gets ONE «Barn» button instead of the three kids types. Picking it shows the kids sizes grouped under a heading
   per fit (Overall (de minste) / Med mansjetter (mindre barn) / Vanlig passform (større barn)) (no price - Kristoffer 30.09: no other picker shows one).
   The same size can sit in two groups (6-8 år exists as both PJ and PA) - the heading makes it a choice, not a duplicate.

   The groups are a skin on top of the real radios: picking a size checks the hidden real Type + Størrelse radios and fires their
   change events, so the theme's variant engine, price, stock, gallery, button and ?variant= work as on any product
   (assets/variant-filter-proxy.js and assets/dmytro-claude-nopreselect.js see an ordinary pick). Our own inputs carry no
   data-variant-input and point at a form that doesn't exist, so the theme and the cart never see them.
   The fit of a Type value is read from its SKUs (OV-/PJ-/PA- ...-K-); words per store in snippets/ss-kids-labels.liquid. */
(function () {
  'use strict';
  var cfg = document.querySelector('[data-ss-kids-groups]');
  if (!cfg || cfg.dataset.ssReady) return;
  var typeFs = document.querySelector('.variant-input-wrap[data-index="option1"]');
  var sizeFs = document.querySelector('.variant-input-wrap[data-index="option2"]');
  if (!typeFs || !sizeFs) return;
  var root = typeFs.closest('[data-section-type="product"]') || document;
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }

  var groups = [];
  try { groups = JSON.parse(cfg.textContent); } catch (e) { return; }
  var kidLabel = cfg.getAttribute('data-kid-label') || 'Barn';
  var chooseSize = cfg.getAttribute('data-choose-size') || '';
  var fromText = cfg.getAttribute('data-from') || '';

  // The fit of each Type value comes from its SKUs: OV-/PJ-/PA- ... -K- (kids). A Type whose variants don't all share one kids
  // prefix is left alone. Groups follow the configured order; fewer than two kids fits = nothing to group
  var lineOf = {};
  variants.forEach(function (v) {
    var m = /^(OV|PJ|PA)-.+-K-/.exec((v.sku || '').trim());
    var line = m ? m[1].toLowerCase() : null;
    if (!(v.option1 in lineOf)) lineOf[v.option1] = line;
    else if (lineOf[v.option1] !== line) lineOf[v.option1] = null;
  });
  var typeOf = {};
  Object.keys(lineOf).forEach(function (t) { var l = lineOf[t]; if (l && !typeOf[l]) typeOf[l] = t; });
  // with an Overall group on the product the PJ heading uses label_ov («Med mansjetter (2-delt)»), else «(mindre barn)»
  var hasOv = !!typeOf.ov;
  groups = groups.filter(function (g) { return typeOf[g.line]; }).map(function (g) {
    return { type: typeOf[g.line], label: (hasOv && g.line === 'pj' && g.label_ov) ? g.label_ov : g.label };
  });
  if (groups.length < 2) return;
  cfg.dataset.ssReady = '1';
  var kidTypes = groups.map(function (g) { return g.type; });

  var sizeWrap = sizeFs.closest('.variant-wrapper');
  var form = document.getElementById(cfg.getAttribute('data-form'));
  var btn = form && form.querySelector('[data-add-to-cart]');

  function realInput(fs, value) {
    var el = Array.prototype.find.call(fs.querySelectorAll('.variant-input'), function (x) { return x.getAttribute('data-value') === value; });
    return el && el.querySelector('input');
  }
  function heading(wrap) { return wrap && wrap.closest('.variant-wrapper').querySelector('[data-ss-opt-value]'); }
  function money(cents) {
    return (window.theme && theme.Currency && theme.settings) ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : String(cents / 100);
  }
  // «Barn» with no size yet: the price line would still show the last type's price (Dame 599 kr). Show the kids price instead,
  // «fra 369 kr» when the kids prices differ, no sale styling - the theme writes the real price once a size is picked
  var priceBefore = null, priceKids = null;
  // Back from «Barn» to Dame while nothing is chosen: the theme doesn't touch the price then, so put the server's line back.
  // Once a variant exists the theme rewrites it right after this anyway
  function restorePrice() {
    var el = root.querySelector('[data-product-price]');
    if (el && priceBefore !== null && el.textContent === priceKids) el.innerHTML = priceBefore;
    priceBefore = priceKids = null;
  }
  function kidsPrice() {
    var el = root.querySelector('[data-product-price]'); if (!el) return;
    if (priceBefore === null) priceBefore = el.innerHTML;
    var ps = variants.filter(function (v) { return kidTypes.indexOf(v.option1) > -1; }).map(function (v) { return v.price; });
    if (!ps.length) return;
    var min = Math.min.apply(null, ps), max = Math.max.apply(null, ps);
    el.textContent = (min !== max && fromText) ? fromText.replace('[price]', money(min)) : money(min);
    priceKids = el.textContent;
    el.classList.remove('on-sale');
    var cmp = root.querySelector('[data-product-price-wrap]'); if (cmp) cmp.classList.add('hide');
  }
  var uid = 0;
  function radio(name, value, type) {
    var id = 'ss-kg-' + (++uid);
    var wrap = document.createElement('div');
    wrap.className = 'variant-input';
    wrap.setAttribute('data-value', value);
    var input = document.createElement('input');
    input.type = type || 'radio'; input.name = name; input.value = value; input.id = id;
    input.setAttribute('form', 'ss-kg-none');
    var label = document.createElement('label');
    label.className = 'variant__button-label'; label.htmlFor = id;
    wrap.appendChild(input); wrap.appendChild(label);
    return { wrap: wrap, input: input, label: label };
  }

  // --- Type row: hide the kids types, one «Barn» button in the place of the first ---
  var kidEls = Array.prototype.filter.call(typeFs.querySelectorAll('.variant-input'), function (el) { return kidTypes.indexOf(el.getAttribute('data-value')) > -1; });
  // A checkbox, not a radio: assets/variant-filter-proxy.js reads the first checked RADIO in the Type row as the chosen type,
  // and a radio «Barn» would make it hide and uncheck every real size
  var barn = radio('ss-kg-type', kidLabel, 'checkbox');
  barn.input.className = 'ss-kg-barn';
  barn.label.textContent = kidLabel;
  kidEls[0].parentNode.insertBefore(barn.wrap, kidEls[0]);
  kidEls.forEach(function (el) { el.style.display = 'none'; });

  // --- The grouped sizes, under the Størrelse heading (so the size guide link stays) ---
  var panel = document.createElement('div');
  panel.className = 'ss-kg';
  panel.hidden = true;
  var chips = [];
  groups.forEach(function (g) {
    var vs = variants.filter(function (v) { return v.option1 === g.type; });
    var head = document.createElement('div');
    head.className = 'ss-kg__head';
    head.textContent = g.label;
    var fs = document.createElement('fieldset');
    fs.className = 'variant-input-wrap ss-two-line ss-two-line-active ss-kg__group';
    vs.forEach(function (v) {
      var c = radio('ss-kg-size', v.option2);
      var parts = v.option2.split(' (');
      if (parts.length > 1) {
        c.label.innerHTML = '<span class="ss-age"></span><span class="ss-cm"></span>';
        c.label.firstChild.textContent = parts[0].replace(/^Overall\s+/, '');
        c.label.lastChild.textContent = parts[1].replace(')', '');
      } else {
        c.label.textContent = v.option2;
      }
      c.input.dataset.type = g.type;
      c.variant = v;
      chips.push(c);
      fs.appendChild(c.wrap);
    });
    panel.appendChild(head);
    panel.appendChild(fs);
  });
  sizeFs.parentNode.insertBefore(panel, sizeFs.nextSibling);

  // Sold out = the theme's crossed-out look (still clickable). The theme's init marks every .variant-input-wrap disabled
  // before it enables the real groups, so this runs again after it
  function markChips() {
    barn.input.classList.remove('disabled'); barn.label.classList.remove('disabled');
    chips.forEach(function (c) {
      c.input.classList.toggle('disabled', !c.variant.available);
      c.label.classList.toggle('disabled', !c.variant.available);
    });
  }

  function realType() { var r = typeFs.querySelector('input[data-variant-input]:checked'); return r ? r.value : null; }
  function realSize() { var r = sizeFs.querySelector('input[data-variant-input]:checked'); return r ? r.value : null; }

  function show(on) {
    barn.input.checked = on;
    panel.hidden = !on;
    sizeFs.style.display = on ? 'none' : '';
    if (on && sizeWrap) { sizeWrap.style.display = ''; sizeWrap.removeAttribute('data-ss-nopre-later'); }
    if (!on) chips.forEach(function (c) { c.input.checked = false; });
  }

  // Keep «Type: Barn» in the heading instead of «Barn Løs» (the inline sync script writes the real value first)
  function typeHeading() { var h = heading(typeFs); if (h && barn.input.checked) h.textContent = kidLabel; }

  function syncFromReal() {
    var t = realType(), s = realSize();
    if (!t && barn.input.checked) return; // «Barn» picked, size not yet - keep the groups open
    var kid = kidsOnly || kidTypes.indexOf(t) > -1;
    show(kid);
    if (kid) chips.forEach(function (c) { c.input.checked = c.input.dataset.type === t && c.input.value === s; });
    typeHeading();
  }

  // Capture phase: assets/dmytro-claude-nopreselect.js stops a lone Type pick (capture, on document) from reaching bubble
  // listeners while nothing is chosen - Barn -> Dame never reached us and the kids groups stayed open (Kristoffer 30.09).
  // stopPropagation does not stop other listeners on the same node, so a capture listener here still sees it
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;

    if (t === barn.input) {
      if (!barn.input.checked) { barn.input.checked = true; return; } // a second tap on «Barn» keeps it on, like a radio
      // «Barn» on its own is not a variant: clear the real Type and Størrelse so nothing else looks chosen, and wait for a size.
      // data-ss-nopre on our config stops assets/variant-filter-proxy.js from re-picking a size by itself meanwhile (it only
      // checks that the attribute exists somewhere; assets/dmytro-claude-nopreselect.js reads it once at load, not again)
      Array.prototype.forEach.call(root.querySelectorAll('.variant-input-wrap[data-index] input[data-variant-input]'), function (r) { r.checked = false; });
      cfg.setAttribute('data-ss-nopre', '');
      show(true);
      var h1 = heading(typeFs); if (h1) h1.textContent = kidLabel;
      var h2 = heading(sizeFs); if (h2) h2.textContent = '';
      if (btn) {
        btn.disabled = true;
        var txt = btn.querySelector('[data-add-to-cart-text]');
        if (txt && chooseSize) txt.textContent = chooseSize;
      }
      kidsPrice();
      var v = variants.find(function (x) { return kidTypes.indexOf(x.option1) > -1 && x.available && x.featured_media; });
      if (v) root.dispatchEvent(new CustomEvent('variantImageChange', { detail: { variant: v } }));
      return;
    }

    if (t.name === 'ss-kg-size') {
      var ti = realInput(typeFs, t.dataset.type), si = realInput(sizeFs, t.value);
      if (!ti || !si) return;
      cfg.removeAttribute('data-ss-nopre');
      // Both radios first, then ONE change on the size. A change on the Type would let the theme's dynamic variants
      // complete it to the nearest available size and throw away a sold-out pick (8-10 år Vanlig became 1-2 år)
      ti.checked = true; si.checked = true;
      si.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(typeHeading, 0);
      return;
    }

    // A real Type pick (Dame, Herre, Katt ...) - back to the normal size row
    if (t.matches('[data-variant-input]') && typeFs.contains(t) && kidTypes.indexOf(t.value) === -1) { cfg.removeAttribute('data-ss-nopre'); show(false); restorePrice(); }
  }, true);

  // Kids-only product (every Type value is a kids fit, e.g. «Julepysj Barn» with Barn Vanlig + Barn Løs, Kristoffer 30.09):
  // a Type row with one «Barn» button says nothing - hide it and open the groups straight away
  var kidsOnly = Array.prototype.every.call(typeFs.querySelectorAll('input[data-variant-input]'), function (r) { return kidTypes.indexOf(r.value) > -1; });
  var typeWrap = typeFs.closest('.variant-wrapper');
  if (kidsOnly && typeWrap) { typeWrap.style.display = 'none'; barn.input.checked = true; }

  function init() {
    markChips(); syncFromReal();
    if (kidsOnly && !realType()) {
      // nothing chosen yet: the button asks only for the size (dmytro-claude-nopreselect.js says «type & size»)
      show(true);
      if (btn && chooseSize) { var txt = btn.querySelector('[data-add-to-cart-text]'); if (txt) txt.textContent = chooseSize; btn.disabled = true; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
  window.addEventListener('load', function () { setTimeout(init, 0); });
})();
